var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-detail-swiper",class:{'hide-promotion-bottom': _vm.ispromotion, 'has-goods-stock': _vm.isStock <= 0}},[(_vm.index == 0)?_c('product-info'):_vm._e(),_vm._v(" "),(_vm.index == 1)?_c('product-desc'):_vm._e(),_vm._v(" "),(_vm.index == 2)?_c('product-review'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-730bdd8b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/product-detail/DetailBody.vue
// module id = null
// module chunks = 